export default __webpack_public_path__ + "static/media/stonewell_logo.547ae4e8.png";